import { EntityAutocompletePicker } from '@backstage/plugin-catalog-react';
import {
  CatalogEntityFilters,
  EntityExcludeTagFilter,
} from './EntityExcludeTagFilter';

export const EntityExcludeTagPicker = () => (
  <EntityAutocompletePicker<CatalogEntityFilters, 'excludeTags'>
    label="Exclude tags"
    name="excludeTags"
    path="metadata.tags"
    Filter={EntityExcludeTagFilter}
  />
);
